// Map BE errors from admin shift endpoints to friendly Vietnamese strings.
// Spec: docs/admin-shift-management.md §7.4
//
// AxiosClient interceptor unwraps to `error.response.data`, so `err` here is
// `{ statusCode, message, error }`. `message` may be string or string[]
// (class-validator), mirror handling in attendance-error.ts.

export function mapShiftError(err: any): string {
  const status: number | undefined = err?.statusCode || err?.status;
  const raw: string | undefined = Array.isArray(err?.message)
    ? err.message[0]
    : err?.message;

  // Stable error codes (substring match — BE may wrap in sentence form).
  if (raw?.includes('SHIFT_NAME_EXISTS')) return 'Tên ca đã tồn tại.';
  if (raw?.includes('SHIFT_TIME_RANGE_INVALID')) {
    return 'Giờ bắt đầu và kết thúc không được trùng nhau.';
  }
  if (raw?.includes('EMPTY_PAYLOAD')) {
    return 'Cần thay đổi ít nhất một giờ trước khi lưu.';
  }
  if (raw?.includes('UNSUPPORTED_FIELDS')) {
    return 'Trường không được phép sửa (lỗi kỹ thuật).';
  }
  if (raw?.includes('SHIFT_NOT_FOUND')) {
    return 'Ca làm không tồn tại hoặc đã bị xoá.';
  }

  if (status === 401) return 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.';
  if (status === 403) return 'Bạn không có quyền thực hiện thao tác này.';
  if (status === 404) return 'Ca làm không tồn tại hoặc đã bị xoá.';
  if (status === 409) return 'Tên ca đã tồn tại.';

  if (status === 400) {
    // class-validator strings come through here.
    return raw || 'Dữ liệu không hợp lệ.';
  }

  if (status && status >= 500) return 'Lỗi server. Vui lòng thử lại sau.';
  return raw || 'Có lỗi xảy ra. Vui lòng thử lại.';
}
